export default "__VITE_ASSET__BUFyNE4F__"